// Config centralisé de l'identité des 4 services phares de PROXIreduc-28.
// Pour chaque service : nom, URL, logo épuré (pastille ronde) pour l'UI,
// image carrée complète pour le partage social, couleur dominante et SEO.
// Toute nouvelle fonctionnalité peut piocher ici logo + image de partage.
export const SERVICES = {
  "bons-plans": {
    key: "bons-plans",
    label: "Bons plans",
    to: "/bons-plans",
    badge: "/services/badges/bons-plans.png", // pastille ronde (UI)
    uiLogo: "/services/ui/bons-plans.png", // logo carré à coins transparents (UI accueil)
    shareImage: "/services/bons-plans.png", // visuel carré complet (partage)
    shareRoute: "/api/share/bons-plans",
    color: "#E8521B",
    seoTitle: "Tous les bons plans d'Eure-et-Loir — PROXIreduc-28",
    seoDescription:
      "Des réductions chez vos commerces de proximité toute l'année. Créez votre compte gratuit et profitez-en dès aujourd'hui.",
  },
  "demande-de-devis": {
    key: "demande-de-devis",
    label: "Demande de devis",
    to: "/demande-de-devis",
    badge: "/services/badges/demande-de-devis.png",
    uiLogo: "/services/ui/demande-de-devis.png",
    shareImage: "/services/demande-de-devis.png",
    shareRoute: "/api/share/demande-de-devis",
    color: "#E8521B",
    seoTitle: "Demande de devis gratuite en Eure-et-Loir — PROXIreduc-28",
    seoDescription:
      "Décrivez votre besoin : les professionnels près de chez vous vous répondent gratuitement. Comparez et choisissez en toute simplicité.",
  },
  "entre-voisins": {
    key: "entre-voisins",
    label: "Entre Voisins",
    to: "/entre-voisins",
    badge: "/services/badges/entre-voisins.png",
    uiLogo: "/services/ui/entre-voisins.png",
    shareImage: "/services/entre-voisins.png",
    shareRoute: "/api/share/entre-voisins",
    color: "#E8521B",
    seoTitle: "Entre Voisins — l'entraide locale gratuite | PROXIreduc-28",
    seoDescription:
      "Coups de main, prêts et petits services entre habitants d'Eure-et-Loir. L'entraide locale, 100 % gratuite, près de chez vous.",
  },
  "petites-annonces": {
    key: "petites-annonces",
    label: "Petites annonces",
    to: "/petites-annonces",
    badge: "/services/badges/petites-annonces.png",
    uiLogo: "/services/ui/petites-annonces.png",
    shareImage: "/services/petites-annonces.png",
    shareRoute: "/api/share/petites-annonces",
    color: "#E8521B",
    seoTitle: "Petites annonces locales en Eure-et-Loir — PROXIreduc-28",
    seoDescription:
      "Achetez, vendez et dénichez de bonnes affaires entre voisins près de chez vous. Déposez votre annonce gratuitement.",
  },
};

// Retourne le service dont l'URL correspond au chemin donné (ou null).
export const getServiceByPath = (path = "/") =>
  Object.values(SERVICES).find((s) => path === s.to || path.startsWith(s.to + "/")) || null;
